module.exports = __webpack_public_path__ + "img/New-Logo.cfab21c3.png";